/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramCategoryControllerGetMetaTreeQueryResponse,
  TelegramCategoryControllerGetMetaTreeQueryParams,
} from '../../types/TelegramCategoryControllerGetMetaTree.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCategoryGetMetaTree } from '../../methods/telegramCategoryGetMetaTree.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCategoryGetMetaTreeQueryKey = (params?: TelegramCategoryControllerGetMetaTreeQueryParams) =>
  [{ url: '/api/telegram/category/meta-tree' }, ...(params ? [params] : [])] as const;

export type TelegramCategoryGetMetaTreeQueryKey = ReturnType<typeof telegramCategoryGetMetaTreeQueryKey>;

export function telegramCategoryGetMetaTreeQueryOptions(
  params?: TelegramCategoryControllerGetMetaTreeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramCategoryGetMetaTreeQueryKey(params);
  return queryOptions<
    TelegramCategoryControllerGetMetaTreeQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramCategoryControllerGetMetaTreeQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCategoryGetMetaTree(params, config);
    },
  });
}

/**
 * {@link /api/telegram/category/meta-tree}
 */
export function useTelegramCategoryGetMetaTree<
  TData = TelegramCategoryControllerGetMetaTreeQueryResponse,
  TQueryData = TelegramCategoryControllerGetMetaTreeQueryResponse,
  TQueryKey extends QueryKey = TelegramCategoryGetMetaTreeQueryKey,
>(
  params?: TelegramCategoryControllerGetMetaTreeQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCategoryControllerGetMetaTreeQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCategoryGetMetaTreeQueryKey(params);

  const query = useQuery(
    {
      ...telegramCategoryGetMetaTreeQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
